export const countWords = (text) =>
  (text ?? "").trim() === "" ? 0 : text.trim().split(/\s+/).length;
